<template>
    <div class="page-content">
        <div class="section main-section">
            <h1>Edit Profile</h1>

            <img src="assets/images/avatar2.png" alt="Camelia Jenssen's avatar" class="avatar" />

            <div class="avatar-buttons">
                <button class="upload-btn">Upload New Photo</button>
                <button class="remove-btn">Remove Photo</button>
            </div>

            <form>
                <div class="field">
                    <label>Email Address</label>
                    <div class="input">
                        <input type="email" value="camelia.jenssen@example.com" />
                    </div>
                </div>
                <div class="field user-field">
                    <label>Username</label>
                    <div class="input">
                        <span>@</span>
                        <input type="text" value="j.camelia" />
                    </div>
                </div>
                <div class="field">
                    <label>Password</label>
                    <div class="input">
                        <input type="password" />
                    </div>
                </div>
                <div class="field">
                    <label>First Name</label>
                    <div class="input">
                        <input type="text" value="Camelia" />
                    </div>
                </div>
                <div class="field">
                    <label>Last Name</label>
                    <div class="input">
                        <input type="text" value="Jenssen" />
                    </div>
                </div>
                <div class="field">
                    <label>Short Bio</label>
                    <div class="input">
                        <textarea>I am an avid traveller. Been to places like Italy, Madagascar, Slovakia and Dubai.</textarea>
                    </div>
                </div>
            </form>

            <button class="deactivate-btn">Deactivate Account</button>

            <div class="profile-buttons">
                <button class="main-btn-outline cancel-btn">Cancel</button>
                <button class="main-btn update-btn">Update Profile</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'EditProfile',
        beforeCreate: function() {
            let body = document.querySelector('body')
            body.dataset.page = 'edit-profile'
        }
    }
</script>

<style scoped lang="scss">
    .section {
        margin-left: auto;
        margin-right: auto;
        max-width: 690px;

        @media (min-width: $breakpoint + 1) and (max-width: 690px + 30) {
            padding: 0 15px;
        }
    }


    .avatar {
        display: block;
        margin-left: auto;
        margin-right: auto;
        border: 10px solid $light-blue;

        @media all and (min-width: $breakpoint + 1) {
            margin-top: 55px;
            width: 180px;
            height: 180px;
        }

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
            width: 160px;
            height: 160px;
        }
    }


    .avatar-buttons {
        display: flex;
        justify-content: center;
        margin-top: 37px;

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
        }
    }


    .avatar-buttons button {
        font-size: 14px;
    }

    .avatar-buttons .upload-btn {
        font-weight: $heavy;
        color: $accent;
    }

    .avatar-buttons .remove-btn {
        margin-left: 52px;
        font-weight: $book;
        color: $dark-gray;

        @media all and (max-width: $breakpoint) {
            margin-left: 40px;
        }
    }


    form {
        margin-top: 60px;

        @media all and (max-width: $breakpoint) {
            margin-top: 40px;
        }
    }


    .field {

        @media all and (min-width: $breakpoint + 1) {
            display: flex;
        }
    }

    .field:not(:first-child) {
        margin-top: 36px;

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
        }
    }


    form label {
        margin-top: 8px;
        padding-right: 15px;
        width: 140px;
        font-weight: $medium;
        font-size: 14px;
        color: #797979;
    }


    .field .input,
    .field input,
    .field textarea {
        width: 100%;
    }

    .field .input {
        position: relative;

        @media all and (max-width: $breakpoint) {
            margin-top: 5px;
        }
    }

    [type="email"],
    [type="text"],
    [type="password"],
    textarea {
        // color: #797979;
        font-size: 14px;
        border: 1px solid $light-gray;
    }

    [type="email"],
    [type="text"],
    [type="password"] {
        padding: 0 16px;
        height: 36px;
        line-height: 36px;
    }

    textarea {
        padding: 10px 16px;
        height: 88px;
        line-height: 24px;
    }

    .user-field [type="text"] {
        padding-left: 30px;
    }


    .user-field span {
        position: absolute;
        display: block;
        top: 0;
        left: 16px;
        bottom: 0;
        height: 36px;
        line-height: 38px;
        font-size: 16px;
        color: $dark-gray;
    }


    .deactivate-btn {
        margin-top: 36px;
        font-weight: $medium;
        font-size: 14px;
        color: $accent-two;

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
        }
    }


    .profile-buttons {
        display: flex;
        justify-content: center;
        margin-top: 64px;

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
        }
    }


    .profile-buttons button {

        @media all and (max-width: $breakpoint) {
            padding: 0;
            width: 50%;
            min-width: initial;
        }
    }

    .profile-buttons .cancel-btn {
        color: $dark-gray;
        border-color: $dark-gray;

        @media all and (min-width: $breakpoint + 1) {
            padding: 0 45px;
            min-width: initial;
        }
    }


    .profile-buttons .update-btn {

        @media all and (min-width: $breakpoint + 1) {
            margin-left: 58px;
            padding: 0 33px;
        }

        @media all and (max-width: $breakpoint) {
            margin-left: 10px;
        }
    }
</style>
